import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Mark, Xp } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { shareTargets } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const AchievementDetail = () => {
  const { showToast } = useWeb();

  return (
    <div className="web-grid two">
      <div>
        <div className="web-shot" style={{ minHeight: 280, marginBottom: 16 }}>
          <Icon name="trophy" />
        </div>
        <h1 style={{ marginTop: 0 }}>Won 2nd Prize – Inter-College Hackathon</h1>
        <div className="web-mut">3 photos · Certificate · 12 Apr 2025 · <Xp amount={150} /></div>
        <p>
          Thrilled to have won 2nd prize at the Inter-College Hackathon. Learned a lot, met amazing people, and can&apos;t wait for the next challenge.
        </p>
        <span className="web-tag">Hackathon</span>
        <span className="web-tag">Technology</span>
        <span className="web-tag">Teamwork</span>
      </div>
      <div className="web-card">
        <b>Share achievement</b>
        <p className="web-mut">Show your success and inspire others.</p>
        <div className="web-grid two">
          {shareTargets.map((target) => (
            <button key={target.label} type="button" className="web-card web-row" onClick={() => showToast(`Shared to ${target.label}`)}>
              <Mark name={target.icon} from={target.color} to={target.color} />
              {target.label}
            </button>
          ))}
        </div>
        <button type="button" className="web-btn soft" style={{ marginTop: 16 }} onClick={() => showToast('Card downloaded')}>
          Download card
        </button>
      </div>
    </div>
  );
};

export default AchievementDetail;
